export default __webpack_public_path__ + "static/media/logo.b78d38bd.png";